export class EcosystemCategoryModel {
  private readonly _value?: string
  private readonly _label?: string

  constructor (label?: string, value?: string) {
    this._value = value
    this._label = label
  }

  get value () {
    return this._value
  }

  get label () {
    return this._label
  }
}